module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.f1515a4.svg";